<template>
  <div class="flex w-full flex-col">
    <component :is="data.icon" class="mb-6 h-12 w-12 fill-green-800 lg:mb-8" />
    <h3
      class="font-bold"
      :class="[
        segment === 'enterprise' || segment === 'wholesale'
          ? '!text-base sm:!text-base md:!text-base lg:!text-lg xl:!text-xl'
          : '!text-base sm:!text-lg md:!text-lg lg:!text-lg xl:!text-lg',
        data.description ? '!mb-2' : '!mb-0',
      ]"
    >
      {{ data.title }}
    </h3>
    <p v-if="data.description" class="mb-4" v-html="data.description"></p>
    <ul v-if="data.list" class="mb-4 text-base font-light lg:text-lg">
      <li v-for="item in data.list" :key="item" class="flex items-center gap-3">
        <IconCheck class="size-[18px] flex-shrink-0 fill-green-700" />
        <span>{{ item }}</span>
      </li>
    </ul>

    <BtnSecondary
      v-if="data.link"
      :label="data.link.label"
      :url="data.link.url"
      size="large"
      arrow="right"
      class="mt-auto"
    />

    <BtnPrimary
      v-if="data.button"
      :label="data.button.label"
      size="large"
      arrow="none"
      class="mt-auto !w-full !justify-start lg:!w-max"
      @click="emit('click')"
    />
  </div>
</template>
<script setup lang="ts">
import type { Segment } from "@/types";

const props = defineProps<{
  data: CardIconData;
  segment: Segment;
}>();

const emit = defineEmits(["click"]);
</script>
